export function DemonMark({ className = '' }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 120 120" aria-hidden="true" focusable="false">
      <ellipse cx="60" cy="82" rx="31" ry="25" fill="currentColor" />
      <ellipse cx="23" cy="52" rx="13" ry="17" transform="rotate(-24 23 52)" fill="currentColor" />
      <ellipse cx="48" cy="39" rx="13" ry="17" transform="rotate(-8 48 39)" fill="currentColor" />
      <ellipse cx="76" cy="39" rx="13" ry="17" transform="rotate(8 76 39)" fill="currentColor" />
      <ellipse cx="99" cy="53" rx="13" ry="17" transform="rotate(24 99 53)" fill="currentColor" />
      <path d="m33 37 4-20 10 15m27 0 10-15 4 20" fill="var(--dp-color-amber)" stroke="var(--dp-color-amber)" strokeLinejoin="round" strokeWidth="4" />
      <path d="m17 43-7-15 15 8m72 1 15-8-7 15" fill="var(--dp-color-amber)" stroke="var(--dp-color-amber)" strokeLinejoin="round" strokeWidth="4" />
    </svg>
  );
}
